module.exports = __webpack_public_path__ + "static/media/TWI logo_white.84882345.png";